<template>
  <div>
    <div class="text-left pd-b-3 flex-display ai-center js-end pd-t-4">
      <a
        @click="[resetAssignment(),setCourse(), (dialogAssignmentVisible = true)]"
        class="color-primary-light"
        >+ เพิ่ม งานที่ได้รับมอบหมาย</a
      >
    </div>
    <div>
      <el-table
        v-if="showTable"
        :data="assignmentList"
        border
        :header-row-style="tableHeaderStyle"
        :header-cell-style="tableHeaderStyle"
        empty-text="ไม่พบข้อมูล"
        v-loading="loading"
      >
        <el-table-column
          type="index"
          label="ลำดับ"
          header-align="center"
          align="center"
          width="80"
        ></el-table-column>
        <el-table-column
          prop="name"
          label="ชื่อหัวข้องานที่ได้รับมอบหมาย"
          header-align="center"
          sortable
          :width="widthMax < 767.98 ? '160' : ''"
        ></el-table-column>
        <el-table-column
          prop="attach"
          label="ไฟล์ประกอบ"
          width="200"
          header-align="center"
          align="center"
          sortable
        >
          <template slot-scope="scope">
            <a
              v-if="scope.row.attach.length > 0"
              :href="`${urlCouse}${$route.query.courseId}/${scope.row.attach[0].file}`"
              target="_blank"
              class="color-primary-light text-underline"
              >{{ scope.row.attach[0].default }}</a
            >
            <p v-else>-</p>
          </template>
        </el-table-column>
        <el-table-column
          prop="durationTime"
          label="เปิด-ปิดงานที่ได้รับมอบหมาย"
          header-align="center"
          align="center"
          width="350"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.durationTime.open">
              {{ scope.row.durationTime.open | dateTimeThShort }} -
              {{ new Date(scope.row.durationTime.close).setHours(23,59,59) | dateTimeThShort }}
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="updatedAt"
          label="วันที่และเวลาที่อัปเดต"
          :width="
            widthMax < 767.98
              ? '160'
              : widthMax < 1199
              ? '160'
              : widthMax > 1200
              ? '250'
              : ''
          "
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">{{
            scope.row.updatedAt | dateTimeTh
          }}</template>
        </el-table-column>
        <el-table-column label width="100" header-align="center" align="center">
          <template slot-scope="scope">
            <div class="flex-display ai-center js-center">
              <div class="box-action">
                <div
                  @click="openAssignment(scope.row._id)"
                  class="circle-action color-bg-secondary"
                >
                  <i class="fas fa-pen"></i>
                </div>
              </div>
              <div class="box-action">
                <el-popconfirm
                  confirmButtonText="ใช่"
                  cancelButtonText="ไม่"
                  icon="el-icon-info"
                  iconColor="red"
                  title="ท่านต้องการลบรายการนี้ใช่หรือไม่"
                  @onConfirm="delAssignment(scope.row._id)"
                >
                  <div
                    slot="reference"
                    class="circle-action color-bg-danger-lighter"
                  >
                    <i class="fas fa-trash-alt"></i>
                  </div>
                </el-popconfirm>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      title
      :visible.sync="dialogAssignmentVisible"
      width="90%"
      top="1vh"
    >
      <div v-loading="loadingDialog">
        <div class="text-left pd-b-3 border-b">
          <h2 class="mg-less text-font-24 color-black">
            {{
              assignmentEdit == false
                ? "เพิ่มงานที่ได้รับมอบหมาย (Assignment) "
                : "แก้ไขงานที่ได้รับมอบหมาย (Assignment) "
            }}
          </h2>
        </div>
        <div class="text-left">
          <p class="text-font-16">
            <span class="color-black">ชื่อหลักสูตร: </span>
            <span class="color-gray">{{ course.name }}</span>
            <span class="color-black pd-l-4">วิชา: </span>
            <span class="color-gray">{{ subject.name }}</span>
          </p>
        </div>
        <div v-if="dialogAssignmentVisible">
          <AssignmentForm
            :type="assignmentEdit == false ? 'add' : 'update'"
            :assignment="assignment"
            :startDate="subject.durationTime.open"
            :endDate="subject.durationTime.close"
            @createAssignment="createAssignment"
            @updateAssignment="updateAssignment"
          />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { tableHeaderStyle } from "@/service/table";
import AssignmentForm from "@/components/assignment/AssignmentForm";
import { HTTP } from "@/service/axios.js";

export default {
  components: {
    AssignmentForm,
  },
  props: {
    assignmentList: {
      type: Array,
      default() {
        return [];
      },
    },
    showView: {
      type: Boolean,
      default() {
        return true;
      },
    },
    courseId:{
      type:String,
      default(){
        return ''
      }
    },
    subjectId:{
      type:String,
      default(){
        return ''
      }
    }
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    courseList() {
      return this.$store.state.courseList;
    },
  },
  data() {
    return {
      widthMax: window.innerWidth,
      showTable:true,
      dialogAssignmentVisible: false,
      assignmentEdit: false,
      urlCouse: process.env.VUE_APP_BASE_URL_FILE_COURSE,
      loading: false,
      loadingDialog: false,
      assignment: null,
      course: "",
      subject: "",
    };
  },
  mounted() {
    this.setCourse();
    window.addEventListener("resize", this.resize);
  },
  methods: {
    resize() {
      this.showTable = false
      this.widthMax= window.innerWidth
      setTimeout(() => {
        this.showTable = true
      }, 200);

    },
    setCourse() {
      let filter = this.courseList.filter(
        (filter) => filter._id == this.$route.query.courseId
      );

      if (filter.length > 0) {
        this.course = filter[0];
        let course = filter[0].subject.filter(
          (filter) => filter._id == this.$route.query.subjectId
        );
        if (course.length > 0) {
          this.subject = course[0];
        }
      }
    },
    delAssignment(id) {
      this.loading = true;
      let obj = {
        _id: id,
        courseId: this.$route.query.courseId,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`delete/assignment`, obj)
        .then((res) => {
          if (res.data.success) {
            this.$emit("fetchSubjectId");
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("delSubject error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
    createAssignment(data) {
      this.loadingDialog = true;
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      let formData = new FormData();
      formData.append("courseId", this.$route.query.courseId);
      formData.append("subjectId", this.$route.query.subjectId);
      formData.append("name", data.assignmentName);

      formData.append(
        "durationTime",
        JSON.stringify({
          open: data.assignmentDistanceDate[0],
          close: data.assignmentDistanceDate[1],
        })
      );

      formData.append("description", data.assignmentDescription);

      data.assignmentFile.map((item, index) => {
        if (item.raw != null && typeof item.raw != "undefined") {
          formData.append("attach", item.raw);
        }
      });

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`assignment`, formData, config)
        .then((res) => {
          if (res.data.success) {
            this.$emit("fetchSubjectId");
            this.dialogAssignmentVisible = false;
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("createAssignment error", e);
        })
        .finally(() => {
          this.loadingDialog = false;
        });
    },
    resetAssignment() {
      this.assignmentEdit = false;
      this.assignment = null;
    },
    openAssignment(id) {
      this.setCourse();
      this.dialogAssignmentVisible = true;
      this.assignmentEdit = true;
      this.loadingDialog = true;

      let obj = {
        _id: id,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`get/assignment`, obj)
        .then((res) => {
          if (res.data.success) {
            this.assignment = res.data.obj;
          }
        })
        .catch((e) => {
          console.log("openAssignment error", e);
        })
        .finally(() => {
          this.loadingDialog = false;
        });
    },
    updateAssignment(data, del, id) {
      this.loadingDialog = true;
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      let formData = new FormData();
      formData.append("_id", id);
      formData.append("courseId", this.$route.query.courseId);
      formData.append("subjectId", this.$route.query.subjectId);
      formData.append("name", data.assignmentName);
      formData.append("description", data.assignmentDescription);

      formData.append(
        "durationTime",
        JSON.stringify({
          open: data.assignmentDistanceDate[0],
          close: data.assignmentDistanceDate[1],
        })
      );

      del.assignmentFileDel.map((item, index) => {
        formData.append("delFiles", item);
      });

      data.assignmentFile.map((item, index) => {
        if (item.raw != null && typeof item.raw != "undefined") {
          formData.append("attach", item.raw);
        }
      });

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.put(`assignment`, formData, config)
        .then((res) => {
          if (res.data.success) {
            this.$emit("fetchSubjectId");
            this.dialogAssignmentVisible = false;
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("createAssignment error", e);
        })
        .finally(() => {
          this.loadingDialog = false;
        });
    },
  },
};
</script>